import { Target, Lightbulb, TrendingUp } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const PillarsSection = () => {
  const { t } = useLanguage();

  const pillars = [
    {
      icon: Target,
      title: t("Strategy", "الاستراتيجية"),
      description: t(
        "We believe in military strategy that we can create unpredictable moves toward the market shaping the blueprint for followers, communicating niche market with brand marketing and actionable knowledge.",
        "نؤمن بالاستراتيجية العسكرية التي تمكننا من إنشاء تحركات غير متوقعة نحو السوق لتشكيل المخطط للمتابعين، والتواصل مع السوق المتخصص من خلال تسويق العلامة التجارية والمعرفة القابلة للتطبيق."
      ),
    },
    {
      icon: Lightbulb,
      title: t("Creativity", "الإبداع"),
      description: t(
        "Obsessed with customers helping clients to frame their objectives by empathizing the market first then leading it by storytelling and creative brains.",
        "مهووسون بالعملاء لمساعدتهم على صياغة أهدافهم من خلال التعاطف مع السوق أولاً ثم قيادته من خلال السرد القصصي والعقول المبدعة."
      ),
    },
    {
      icon: TrendingUp,
      title: t("Media", "الإعلام"),
      description: t(
        "We are trading attention by providing values through media channels with technical and tactical skills aiming for business outcomes not potential reach.",
        "نحن نتداول الانتباه من خلال تقديم القيمة عبر القنوات الإعلامية بمهارات تقنية وتكتيكية تهدف إلى نتائج الأعمال وليس الوصول المحتمل."
      ),
    },
  ];

  return (
    <section className="py-20 lg:py-32 bg-card" id="pillars">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-4 tracking-tight">
            {t("PILLARS", "الركائز")}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="text-center group"
            >
              <div className="w-24 h-24 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-8 group-hover:bg-primary/20 transition-colors">
                <pillar.icon className="w-12 h-12 text-primary" />
              </div>
              <h3 className="text-2xl font-bold text-foreground mb-4">
                {pillar.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PillarsSection;
